import { FunctionComponent } from "react";
import { cn } from "../../../utils/cn";

export interface StatWithDetailsProps {
  className?: string;
  heading: string;
  value: string;
  detail1?: string;
  detail2?: string;
}

/**
 *
 */
export const StatWithDetails: FunctionComponent<StatWithDetailsProps> = ({
  className,
  heading,
  value,
  detail1,
  detail2,
}) => {
  const css = cn(
    "h-24 flex flex-col justify-center items-center px-2 sm:px-4 border-0 rounded-2xl ",
    className,
  );
  const dataTestId = heading.replace(/ /g, "-").toLowerCase() + "-statistics";
  const ariaLabel = heading + " statistics value";
  return (
    <div className={css} data-testid={dataTestId}>
      <div className="text-xs font-semibold sm:text-sm">{heading}</div>
      <div className="text-md font-bold sm:text-lg" aria-label={ariaLabel}>
        {value}
      </div>
      {detail1 && <div className="text-xs text-gray-500">{detail1}</div>}
      {detail2 && <div className="text-xs text-gray-500">{detail2}</div>}
    </div>
  );
};
